import moment from 'moment';

export const ISO_DATE_FORMAT = 'YYYY-MM-DD';

export function isoDateDaysAgo(days: number): string {
    return moment().subtract(days, 'days').format(ISO_DATE_FORMAT);
}
